import React from 'react';
import { Chip, type SxProps, type Theme } from '@mui/material';
import {
  AutoAwesomeMosaicOutlined,
  type SvgIconComponent,
} from '@mui/icons-material';

import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

import { chipSx } from './styles';

export type Status =
  | 'Validate'
  | 'Active'
  | 'In Progress'
  | 'Waiting for launch'
  | 'Failed'
  | 'Cancelled'
  | 'Empty'
  | 'Phase1';

const STATUS_CONFIG: Record<
  Status,
  { label: string; color: string; Icon: SvgIconComponent }
> = {
  Validate: {
    label: 'Validate',
    color: '#4EDC6B',
    Icon: CheckCircleOutlineOutlinedIcon,
  },
  Active: {
    label: 'Active',
    color: '#4EDC6B',
    Icon: CheckCircleOutlineOutlinedIcon,
  },
  'In Progress': {
    label: 'In Progress',
    color: '#FBBF24',
    Icon: AccessTimeOutlinedIcon,
  },
  'Waiting for launch': {
    label: 'Waiting for launch',
    color: '#FBBF24',
    Icon: AccessTimeOutlinedIcon,
  },
  Failed: {
    label: 'Failed',
    color: '#FF2828',
    Icon: CancelOutlinedIcon,
  },
  Cancelled: {
    label: 'Cancelled',
    color: '#EF4444',
    Icon: CancelOutlinedIcon,
  },
  Empty: {
    label: 'Empty',
    color: '#FF2828',
    Icon: CancelOutlinedIcon,
  },
  Phase1: {
    label: 'Pahse 1',
    color: '#354EEF',
    Icon: AutoAwesomeMosaicOutlined,
  },
};

type StatusChipProps = {
  status: Status;
  small?: boolean;
  sx?: SxProps<Theme>;
};

const StatusChip = ({ status, small, sx }: StatusChipProps) => {
  const config = STATUS_CONFIG[status];
  if (!config) return null;
  const { label, color, Icon } = config;

  return (
    <Chip
      sx={[chipSx(color, small), ...(Array.isArray(sx) ? sx : [sx])]}
      icon={<Icon />}
      label={label}
    />
  );
};

export default StatusChip;
